import React, { useMemo } from 'react';
import routes from 'common/constants/routing.constants';
import history from 'customHistory';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { S } from './styled';

function SwitchAccountTypeRaw({
  AppStore: { getAccountType, changeAccountType },
  ProfileStore: { needInfoAndHaveData },
}) {
  const { t } = useTranslation();

  const switchType = useMemo(
    () => (getAccountType === 'Demo' ? 'Real' : 'Demo'),
    [getAccountType]
  );

  const handleChangeAccountType = (type) => () => {
    if (type === 'Real' && needInfoAndHaveData) {
      history.push(routes.profile.path);
    } else {
      changeAccountType(type);
    }
  };

  return (
    <div>
      <S.SwitchAccountTypeWrapper>
        <S.RealDemo
          onClick={handleChangeAccountType('Demo')}
          demo
          active={getAccountType === 'Demo'}
          data-testid="trading-switch-demo"
        >
          {t('demo')}
        </S.RealDemo>

        <S.FancySwitch
          checked={getAccountType === 'Real'}
          onChange={handleChangeAccountType(switchType)}
        />

        <S.RealDemo
          onClick={handleChangeAccountType('Real')}
          active={getAccountType === 'Real'}
          data-testid="trading-switch-real"
        >
          {t('real')}
        </S.RealDemo>
      </S.SwitchAccountTypeWrapper>
    </div>
  );
}

export const SwitchAccountType = inject(
  'AppStore',
  'ProfileStore'
)(observer(SwitchAccountTypeRaw));
